import React, { useCallback, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
// --- Import Styles
import "../RefundSelectProduct/RefundSelectProduct.sass";

function RefundReasonSelect({
  value,
  options,
  onChange,
  className,
  placeholder,
  errorMsg,
  ...rest
}) {
  const selectRef = useRef();
  const [state, setState] = useState({
    isOpen: false,
  });

  const toggleOptions = useCallback(() => {
    setState({ isOpen: !state.isOpen });
  }, [state]);

  const closeOptions = useCallback(() => {
    setState({ isOpen: false });
  }, []);

  const handleClickOutside = useCallback(
    (e) => {
      if (!selectRef.current.contains(e.target)) {
        closeOptions();
      }
    },
    [selectRef]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div
      ref={selectRef}
      className={`toolbar-select ${
        state.isOpen ? "toolbar-select--open" : ""
      } ${className} ${errorMsg !== "" ? "toolbar-select--error" : ""} ${
        value?.value ? "toolbar-select--selected" : ""
      }`}
      {...rest}
    >
      <div
        role="button"
        tabIndex={0}
        className="toolbar-select-selected"
        onClick={toggleOptions}
        onKeyPress={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            toggleOptions();
          }
        }}
      >
        <span className="toolbar-select-selected__text">
          {value.label || placeholder}
        </span>
        <div className="toolbar-select-selected__icon">
          <span />
        </div>
      </div>
      {state.isOpen && (
        <ul className="toolbar-select-dropdown">
          {options.map((option, i) => {
            return (
              <li
                key={i}
                tabIndex={0}
                role="option"
                aria-selected={+value === option.value}
                className={`toolbar-select-dropdown__option ${
                  +value === option.value
                    ? "toolbar-select-dropdown__option--selected"
                    : ""
                }`}
                onClick={() => {
                  onChange(option);
                  closeOptions();
                }}
                onKeyDown={(e) => {
                  if (!e.shiftKey && e.key === "Enter") {
                    onChange(option);
                    closeOptions();
                  }
                }}
              >
                {option.label}
              </li>
            );
          })}
        </ul>
      )}{" "}
      {errorMsg !== "" && (
        <span className="toolbar-select__error toolbar-select__error--other">
          {errorMsg}
        </span>
      )}
    </div>
  );
}
// --- :propTypes --- //
RefundReasonSelect.propTypes = {
  value: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    )
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  errorMsg: PropTypes.string,
};
RefundReasonSelect.defaultProps = {
  className: "",
  errorMsg: "",
};

// --- propTypes: --- //

export default RefundReasonSelect;
